import React from 'react';
import styles from './DataRow.module.scss';

/**
 * @typedef {object} DataRowProps
 * @property {string} [title]
 * @property {string} [description]
 */

/**
 * @param {DataRowProps} props
 */
const DataRow = props => {
  const { title, description } = props;

  return (
    <p className={styles.row}>
      <span className={styles.title}>{title}</span>
      <span>{description}</span>
    </p>
  );
};

export default DataRow;
